export default "__VITE_ASSET__DwNQD5Al__"